import graphqlClient from '@/graphql/graphql-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  InsertContactsDocument,
  type InsertContactsMutationVariables,
} from '@/graphql/generated/graphql';

export type InsertContactPayload = InsertContactsMutationVariables;

export const useInsertContacts = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationKey: ['insert-contacts'],
    mutationFn: (variables: InsertContactsMutationVariables) =>
      graphqlClient.request(InsertContactsDocument, variables),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['contacts'] });
    },
  });

  return {
    ...mutation,
    insertContacts: mutation.mutate,
    insertContactsAsync: mutation.mutateAsync,
  };
};

export const useInsertContact = useInsertContacts;

export default useInsertContacts;
